import {
  TOGGLE_MODAL,
  TOGGLE_SELECTOR,
  SET_RETURN_FOCUS,
} from "../../actions/Modal";

const initialState = {
  termsAndConditionsModalVisible: false,
  countrySelectorisVisible: false,
  returnFocus: null,
};

const Modal = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MODAL: {
      return Object.assign({}, state, {
        termsAndConditionsModalVisible: !state.termsAndConditionsModalVisible,
        returnFocus: state.returnFocus,
      });
    }
    case TOGGLE_SELECTOR: {
      return Object.assign({}, state, {
        countrySelectorisVisible: !state.countrySelectorisVisible,
      });
    }
    case SET_RETURN_FOCUS: {
      return Object.assign({}, state, {
        returnFocus: action.returnFocus,
      });
    }
    default: {
      return state;
    }
  }
};

export default Modal;
